export default __webpack_public_path__ + "static/media/ratings.0fcc7fb9.svg";